// digitalMarketingData.js

const digitalMarketingData = [

  {
    slug: 'zuvius-lifesciences',

    title: 'Zuvius Lifesciences',

    heroDesc:
      'We helped Zuvius Lifesciences strengthen their online presence and connect with the right audience through strategic digital marketing.',

    industry: 'Pharmaceuticals',

    service: 'Digital Marketing',

    heroImage: '/home-digital.png',

    about:
      'Zuvius Lifesciences is a growing pharmaceutical company with a strong product portfolio. Our goal was to increase brand awareness, educate their audience and generate quality inquiries.',

    highlights: [

      {
        icon: '📈',
        title: 'Stronger',
        desc: 'Brand Presence'
      },

      {
        icon: '💬',
        title: 'Consistent',
        desc: 'Engagement'
      },

      {
        icon: '🎯',
        title: 'More Quality',
        desc: 'Inquiries'
      },

      {
        icon: '🤝',
        title: 'Better Audience',
        desc: 'Connection'
      }

    ],

    approach: [

      {
        icon: '🧠',
        title: 'Understand',
        desc: 'Brand & Audience'
      },

      {
        icon: '📋',
        title: 'Plan',
        desc: 'Strategy & Content'
      },

      {
        icon: '🚀',
        title: 'Execute',
        desc: 'Campaigns'
      },

      {
        icon: '📣',
        title: 'Engage',
        desc: '& Grow'
      }

    ],

    servicesDone: [

      {
        icon: '📱',
        title: 'Social Media Management',
        desc:
          'Regular posting, community interaction and brand building.'
      },

      {
        icon: '🎨',
        title: 'Content Creation & Design',
        desc:
          'Creative and informative content tailored for the audience.'
      },

      {
        icon: '📢',
        title: 'Paid Advertising (FB & IG)',
        desc:
          'Targeted ad campaigns to reach the right audience.'
      },

      {
        icon: '💜',
        title: 'Community Engagement',
        desc:
          'Building trust through meaningful conversations.'
      },

      {
        icon: '📊',
        title: 'Performance Optimization',
        desc:
          'Continuous monitoring and improvement for better results.'
      }

    ],

    posts: [

      '/digital-marketing/zuvius/zuvius-post5.jpeg',
      '/digital-marketing/zuvius/zuvius-post1.png',
      '/digital-marketing/zuvius/zuvius-post2.png',
      '/digital-marketing/zuvius/zuvius-post3.jpeg',
      '/digital-marketing/zuvius/zuvius-post4.jpeg',
      
    ],

    impact: [

      'Stronger brand visibility across digital platforms',

      'Consistent engagement and audience interaction',

      'Increased inquiries and brand trust',

      'Better connection with healthcare professionals and customers'

    ],

    testimonial:
      'WeCanServe has been a great partner in our digital growth journey. Their team understands our brand and delivers content that truly connects with our audience.',

    testimonialName: 'Zuvius Lifesciences Team',

    testimonialRole: 'Marketing Head'

  }

];

export default digitalMarketingData;